
import { defineComponent,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import {useStore} from "vuex";
import router from "@/router";
import Header from '@/components/Header.component.vue'; // @ is an alias to /src
import SideBar from '@/components/SideBar.component.vue'; // @ is an alias to /src
import formupload from '@/components/formupload.component.vue'; // @ is an alias to /src
import {IDoc,IFile} from "@/models/files.interface";
import {FilesService} from "@/services/files.service";
import {UserService} from "@/services/user.service";


export default defineComponent({
name:"Uploadfiles",
 components:{
  Header,
  SideBar,
  formupload
 },
 setup(){
  const userService = new UserService();
  const store = useStore();

  onMounted(()=>{
	try{
	const userStored =  userService.fetch();
	  if(!userStored){
	    router.push("login");
	  }
	  else{
	  
	//router.push("login");
	  }
	}catch(err){
	  console.log(err);
	}
      });

  const logout = ()=>{
         userService.clean();
	 store.dispatch("set_current_user",{token:"",name:"",lastname:"",profiles:[]});
	try{

	router.push("login");
	}catch(err){
          console.log(err);
	}
      };//fin de logout

      return {logout}

 }//fin de setup

});
